// Fragment "HQ customers and platform automation, S8 round 2" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/HqCustomers.jsx (sync summary, name and tag refusals, save errors),
// super_admin/automation/* (rule errors, legacy runs, new detail codes), HqServiceLeads.jsx and
// ActivityLog.jsx. The older hc.* / hauto.* keys stay in base.js.
export default {
  fr: {
    "hc.syncDone": "{synced} cabinets synchronisés sur {tenants}.",
    "hc.syncFailed": "{n} cabinet(s) non synchronisé(s) : {slugs}.",
    "hc.syncError": "La synchronisation n'a pas pu être lancée.",
    "hc.nameEmpty": "Saisissez un nom.",
    "hc.nameInvisible": "Le nom doit contenir au moins un caractère visible.",
    "hc.nameControl": "Le nom ne peut pas contenir de caractères de contrôle.",
    "hc.nameTooLong": "Un nom fait au plus {max} caractères.",
    "hc.tagEmpty": "Une étiquette ne peut pas être vide.",
    "hc.tagInvisible": "Une étiquette doit contenir au moins un caractère visible.",
    "hc.tagNotText": "Une étiquette doit être du texte.",
    "hc.saveFailed": "La modification n'a pas pu être enregistrée.",
    "hc.deleteFailed": "Le client n'a pas pu être supprimé.",
    "hc.commFailed": "L'échange n'a pas pu être enregistré.",
    "hc.stageHint.lead": "N'a pas encore payé",
    "hc.stageHint.trial": "En période d'essai gratuite",
    "hc.stageHint.active": "Abonnement payé, en ligne",
    "hc.stageHint.at_risk": "Paiement en retard, toujours en ligne",
    "hc.stageHint.suspended": "Désactivé (impayé ou sanction)",
    "hc.stageHint.churned": "Abonnement résilié ou cabinet supprimé",
    "hc.arExplainer": "Factures d'abonnement Solunary impayées de ce cabinet, dans la devise de chaque facture.",
    "hc.comm.modeSend": "Envoyer un courriel au cabinet",
    "hc.comm.modeLogReceived": "Consigner un courriel reçu",
    "hc.comm.sendHint": "Envoyé par Solunary à {to}.",
    "hc.comm.logHint": "Consignation seulement : rien n'est envoyé au cabinet.",
    "hc.comm.noRecipient": "Ce client n'a pas d'adresse courriel : aucun courriel ne peut lui être envoyé.",
    "hc.comm.subjectRequired": "Un courriel a besoin d'un sujet.",
    "hc.comm.send": "Envoyer le courriel",
    "hc.comm.log": "Ajouter à l'historique",
    "hc.comm.logged": "Consigné",
    "hc.comm.received": "Reçu",
    "hc.comm.delivery.sending": "Envoi…",
    "hc.comm.delivery.queued": "En file d'attente",
    "hc.comm.delivery.sent": "Envoyé à {to}",
    "hc.comm.delivery.failed": "Non envoyé",
    "hc.comm.delivery.unconfirmed": "Envoi non confirmé",
    "hc.comm.toastSent": "Courriel envoyé à {to}.",
    "hc.comm.toastQueued": "Courriel en file d'attente : il sera envoyé automatiquement.",
    "hc.comm.toastFailed": "Le courriel n'a pas pu être envoyé. Il est consigné comme non envoyé.",
    "hc.comm.toastLogged": "Ajouté à l'historique.",
    "hc.comm.rateLimited": "Trop de courriels à ce client dans la dernière heure. Réessayez plus tard.",
    "hc.comm.requestReused": "Ce message a déjà été enregistré. Actualisez pour le voir.",
    "hc.tagsContended": "Ce client était modifié au même moment. Enregistrez à nouveau.",
    "hc.refresh": "Actualiser",
    "hc.close": "Fermer",
    "hc.refreshFailed": "La fiche n'a pas pu être relue.",
    "hc.automationsBackground": "Les automatisations déclenchées par cette modification s'exécutent en arrière-plan. Actualisez pour voir leur effet.",
    "hc.tenantStatus.deleted": "Supprimé",
    "hc.tenantStatus.relinked": "Détaché : son adresse appartient désormais à un autre cabinet",
    "hc.tenantStatus.past_due": "Paiement en retard",
    "hc.tenantStatus.churned": "Perdu",
    "hauto.status.simulated_legacy": "Simulé · ancien",
    "hauto.detail.invalid_config": "Les réglages de l'action sont illisibles : elle a été ignorée.",
    "hauto.detail.tag_limit_reached": "Le client a déjà le nombre maximal d'étiquettes : « {tag} » n'a pas été ajoutée.",
    "hauto.noPermission": "Vous n'avez pas la permission de modifier les règles d'automatisation.",
    "hauto.err.tenantNotFound": "Ce cabinet n'existe plus. Choisissez-en un autre.",
    "hauto.err.ruleNotFound": "Cette règle n'existe plus.",
    "hauto.err.invalidTrigger": "Ce déclencheur n'est pas disponible.",
    "hauto.err.ruleTooDeep": "Les conditions ou les actions de cette règle sont imbriquées sur plus de {max} niveaux.",
    "hauto.err.invalidActionType": "L'action {n} n'est pas d'un type connu.",
    "hauto.err.invalidActionConfig.other": "Action {n} ({action}) : ses réglages ne sont pas valides.",
    "sl.noPermission": "Vous n'avez pas la permission de modifier les demandes.",
    "act.ev.automation.simulatedLegacy": "Automatisation simulée (ancien format) : {rule}",
    "tp.forbidden": "Votre rôle ne permet pas de rechercher les cabinets.",
  },
  en: {
    "hc.syncDone": "Synced {synced} of {tenants} practices.",
    "hc.syncFailed": "{n} practice(s) could not be synced: {slugs}.",
    "hc.syncError": "The sync could not be run.",
    "hc.nameEmpty": "Enter a name.",
    "hc.nameInvisible": "The name needs at least one visible character.",
    "hc.nameControl": "The name cannot contain control characters.",
    "hc.nameTooLong": "A name is at most {max} characters.",
    "hc.tagEmpty": "A tag cannot be empty.",
    "hc.tagInvisible": "A tag needs at least one visible character.",
    "hc.tagNotText": "A tag must be text.",
    "hc.saveFailed": "The change could not be saved.",
    "hc.deleteFailed": "The client could not be deleted.",
    "hc.commFailed": "The exchange could not be logged.",
    "hc.stageHint.lead": "Has not paid yet",
    "hc.stageHint.trial": "In its free trial",
    "hc.stageHint.active": "Paying, online",
    "hc.stageHint.at_risk": "Payment overdue, still online",
    "hc.stageHint.suspended": "Switched off (unpaid or sanction)",
    "hc.stageHint.churned": "Subscription cancelled or practice deleted",
    "hc.arExplainer": "Unpaid Solunary subscription invoices of this practice, in each invoice's currency.",
    "hc.comm.modeSend": "Send an email to the practice",
    "hc.comm.modeLogReceived": "Log an email received",
    "hc.comm.sendHint": "Sent from Solunary to {to}.",
    "hc.comm.logHint": "Log only: nothing is sent to the practice.",
    "hc.comm.noRecipient": "This client has no email address, so no email can be sent.",
    "hc.comm.subjectRequired": "An email needs a subject.",
    "hc.comm.send": "Send email",
    "hc.comm.log": "Add to history",
    "hc.comm.logged": "Logged",
    "hc.comm.received": "Received",
    "hc.comm.delivery.sending": "Sending…",
    "hc.comm.delivery.queued": "Queued",
    "hc.comm.delivery.sent": "Sent to {to}",
    "hc.comm.delivery.failed": "Not sent",
    "hc.comm.delivery.unconfirmed": "Delivery not confirmed",
    "hc.comm.toastSent": "Email sent to {to}.",
    "hc.comm.toastQueued": "Email queued: it will be sent automatically.",
    "hc.comm.toastFailed": "The email could not be sent. It is recorded as not sent.",
    "hc.comm.toastLogged": "Added to history.",
    "hc.comm.rateLimited": "Too many emails to this client in the last hour. Try again later.",
    "hc.comm.requestReused": "This message was already recorded. Refresh to see it.",
    "hc.tagsContended": "This client was being changed at the same moment. Please save again.",
    "hc.refresh": "Refresh",
    "hc.close": "Close",
    "hc.refreshFailed": "The client could not be read again.",
    "hc.automationsBackground": "Automations triggered by this change run in the background. Refresh to see what they did.",
    "hc.tenantStatus.deleted": "Deleted",
    "hc.tenantStatus.relinked": "Unlinked: its address now belongs to another practice",
    "hc.tenantStatus.past_due": "Past due",
    "hc.tenantStatus.churned": "Churned",
    "hauto.status.simulated_legacy": "Simulated · legacy",
    "hauto.detail.invalid_config": "The action's settings could not be read, so it was skipped.",
    "hauto.detail.tag_limit_reached": "The client already has the maximum number of tags; \"{tag}\" was not added.",
    "hauto.noPermission": "You don't have permission to change automation rules.",
    "hauto.err.tenantNotFound": "This practice no longer exists. Choose another one.",
    "hauto.err.ruleNotFound": "This rule no longer exists.",
    "hauto.err.invalidTrigger": "This trigger is not available.",
    "hauto.err.ruleTooDeep": "This rule's conditions or actions are nested more than {max} levels deep.",
    "hauto.err.invalidActionType": "Action {n} is not a known action type.",
    "hauto.err.invalidActionConfig.other": "Action {n} ({action}): its settings are not valid.",
    "sl.noPermission": "You don't have permission to change service requests.",
    "act.ev.automation.simulatedLegacy": "Automation simulated (legacy): {rule}",
    "tp.forbidden": "Your role cannot search practices.",
  },
  es: {
    "hc.syncDone": "{synced} de {tenants} consultas sincronizadas.",
    "hc.syncFailed": "{n} consulta(s) no se pudieron sincronizar: {slugs}.",
    "hc.syncError": "No se pudo ejecutar la sincronización.",
    "hc.nameEmpty": "Escribe un nombre.",
    "hc.nameInvisible": "El nombre necesita al menos un carácter visible.",
    "hc.nameControl": "El nombre no puede contener caracteres de control.",
    "hc.nameTooLong": "Un nombre tiene como máximo {max} caracteres.",
    "hc.tagEmpty": "Una etiqueta no puede estar vacía.",
    "hc.tagInvisible": "Una etiqueta necesita al menos un carácter visible.",
    "hc.tagNotText": "Una etiqueta debe ser texto.",
    "hc.saveFailed": "No se pudo guardar el cambio.",
    "hc.deleteFailed": "No se pudo eliminar el cliente.",
    "hc.commFailed": "No se pudo registrar el intercambio.",
    "hc.stageHint.lead": "Aún no ha pagado",
    "hc.stageHint.trial": "En su prueba gratuita",
    "hc.stageHint.active": "Suscripción pagada, en línea",
    "hc.stageHint.at_risk": "Pago atrasado, aún en línea",
    "hc.stageHint.suspended": "Desactivada (impago o sanción)",
    "hc.stageHint.churned": "Suscripción cancelada o consulta eliminada",
    "hc.arExplainer": "Facturas de suscripción de Solunary impagas de esta consulta, en la moneda de cada factura.",
    "hc.comm.modeSend": "Enviar un correo a la consulta",
    "hc.comm.modeLogReceived": "Registrar un correo recibido",
    "hc.comm.sendHint": "Enviado por Solunary a {to}.",
    "hc.comm.logHint": "Solo registro: no se envía nada a la consulta.",
    "hc.comm.noRecipient": "Este cliente no tiene dirección de correo: no se le puede enviar ningún correo.",
    "hc.comm.subjectRequired": "Un correo necesita un asunto.",
    "hc.comm.send": "Enviar correo",
    "hc.comm.log": "Añadir al historial",
    "hc.comm.logged": "Registrado",
    "hc.comm.received": "Recibido",
    "hc.comm.delivery.sending": "Enviando…",
    "hc.comm.delivery.queued": "En cola",
    "hc.comm.delivery.sent": "Enviado a {to}",
    "hc.comm.delivery.failed": "No enviado",
    "hc.comm.delivery.unconfirmed": "Envío no confirmado",
    "hc.comm.toastSent": "Correo enviado a {to}.",
    "hc.comm.toastQueued": "Correo en cola: se enviará automáticamente.",
    "hc.comm.toastFailed": "No se pudo enviar el correo. Queda registrado como no enviado.",
    "hc.comm.toastLogged": "Añadido al historial.",
    "hc.comm.rateLimited": "Demasiados correos a este cliente en la última hora. Inténtelo más tarde.",
    "hc.comm.requestReused": "Este mensaje ya se registró. Actualice para verlo.",
    "hc.tagsContended": "Este cliente se estaba modificando al mismo tiempo. Vuelve a guardar.",
    "hc.refresh": "Actualizar",
    "hc.close": "Cerrar",
    "hc.refreshFailed": "No se pudo volver a leer el cliente.",
    "hc.automationsBackground": "Las automatizaciones que activa este cambio se ejecutan en segundo plano. Actualiza para ver su efecto.",
    "hc.tenantStatus.deleted": "Eliminado",
    "hc.tenantStatus.relinked": "Desvinculado: su dirección pertenece ahora a otra consulta",
    "hc.tenantStatus.past_due": "Pago atrasado",
    "hc.tenantStatus.churned": "Perdido",
    "hauto.status.simulated_legacy": "Simulado · antiguo",
    "hauto.detail.invalid_config": "No se pudo leer la configuración de la acción, así que se omitió.",
    "hauto.detail.tag_limit_reached": "El cliente ya tiene el número máximo de etiquetas; «{tag}» no se añadió.",
    "hauto.noPermission": "No tienes permiso para modificar las reglas de automatización.",
    "hauto.err.tenantNotFound": "Esta consulta ya no existe. Elige otra.",
    "hauto.err.ruleNotFound": "Esta regla ya no existe.",
    "hauto.err.invalidTrigger": "Este disparador no está disponible.",
    "hauto.err.ruleTooDeep": "Las condiciones o las acciones de esta regla están anidadas en más de {max} niveles.",
    "hauto.err.invalidActionType": "La acción {n} no es de un tipo conocido.",
    "hauto.err.invalidActionConfig.other": "Acción {n} ({action}): su configuración no es válida.",
    "sl.noPermission": "No tienes permiso para modificar las solicitudes.",
    "act.ev.automation.simulatedLegacy": "Automatización simulada (formato antiguo): {rule}",
    "tp.forbidden": "Tu rol no permite buscar consultas.",
  },
};
